import { useParamsContext } from '../../contexts/ParamsContext';
import AtendentesForm from './Form';
import AtendentesList from './List';
import { AgendaSettings, AgendaSettingsProvider } from '../agenda/estabelecimento/settings/Settings';
import { useSearchParams } from 'react-router-dom';
import { SettingsNav } from '../configuracoes/estabelecimento/Form/SettingsGroup';
import {
    AGENDA_SETTINGS_SECTIONS,
    AgendaSettingsSectionKey,
    DEFAULT_AGENDA_SETTINGS_SECTION,
} from '../agenda/estabelecimento/settings/sections';

function AtendenteAgendaSettings() {
    const [searchParams, setSearchParams] = useSearchParams();
    const attendantId = searchParams.get('attendantId') || '';
    const sectionId = searchParams.get('id') || DEFAULT_AGENDA_SETTINGS_SECTION;
    const availableSections = AGENDA_SETTINGS_SECTIONS.filter((section) =>
        ['geral', 'horarios'].includes(section.key)
    );
    const activeSection = availableSections.find((section) => section.key === sectionId)?.key || DEFAULT_AGENDA_SETTINGS_SECTION;

    const selectSection = (section: AgendaSettingsSectionKey) => {
        setSearchParams({ action: 'agenda-settings', id: section, attendantId });
    };

    return (
        <div className="estab-settings grid gap-6 lg:grid-cols-[17rem_minmax(0,1fr)] lg:items-start">
            <aside className="lg:sticky lg:top-20">
                <SettingsNav
                    label="Seções da agenda"
                    items={availableSections.map((section) => ({ ...section, key: section.key as AgendaSettingsSectionKey }))}
                    activeKey={activeSection as AgendaSettingsSectionKey}
                    onOpen={selectSection}
                    onSelect={selectSection}
                />
            </aside>

            <AgendaSettingsProvider attendantId={attendantId}>
                <AgendaSettings
                    actionName="agenda-settings"
                    showSectionMenu={false}
                    sectionKeys={['geral', 'horarios']}
                    title="Configurações da agenda"
                    description="Defina regras de disponibilidade e horários de atendimento."
                />
            </AgendaSettingsProvider>
        </div>
    );
}

export default function Atendentes() {
    const { action } = useParamsContext();

    switch (action) {
        case 'edit':
        case 'add': {
            return <AtendentesForm />;
        }
        case 'agenda-settings':
            return <AtendenteAgendaSettings />;
        case 'list':
        default:
            return <AtendentesList />;
    }
}
